import { ElMessage } from 'element-plus/es';
import 'element-plus/es/components/message/style/css';
import { onMounted, reactive, toRefs } from "vue";
import apis from "@/api";
import AuditState from "../../Detail/components/AuditState";
export default {
  components: {
    AuditState
  },
  name: "DetailAside",
  props: {
    demandId: {
      type: String
    }
  },
  setup(props, context) {
    const data = reactive({
      activeTab: 'proc',
      processLogs: [],
      activeCollapse: '',
      smsEditLogs: []
    });
    const refresh = () => {
      processLog();
      initEditHis();
    };
    const processLog = () => {
      apis.processLog({
        demandId: props.demandId
      }).then(res => {
        if (res.success) {
          data.processLogs = res.data;
        } else {
          ElMessage.error(res.msg);
        }
      });
    };
    const initEditHis = () => {
      apis.smsEditHis({
        demandId: props.demandId
      }).then(res => {
        if (res.success) {
          data.smsEditLogs = res.data;
        } else {
          ElMessage.error(res.msg);
        }
      });
    };
    onMounted(() => {
      initEditHis();
    });
    return {
      ...toRefs(data),
      refresh
    };
  }
};